import { mission } from "../routes";
const createSubmission = async (data) => {
  try {
    const response = await fetch(mission.createRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const result = await response.json();
      throw new Error("Request failed with status: " + response.status + ", " + result.message);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateSubmission = async (data) => {
  try {
    const response = await fetch(mission.updateRoute, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmissionById = async (data) => {
  try {
    const response = await fetch(mission.getSubmissionById, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify( data ),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmission = async (data) => {
  try {
    const response = await fetch(mission.getSubmission, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        ...data,
        event: "minigametet2026",
      }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const updateSubmissionStatus = async (data) => {
  try {
    const response = await fetch(mission.updateSubmissionStatus, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json(); 
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getSubmissionByLink = async (data) => {
  try {
    const response = await fetch(mission.getSubmissionByLink, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

// Get all submissions without pagination for export
const getAllSubmissions = async (event) => {
  try {
    const response = await fetch(mission.getSubmission, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        event,
        sortField: "updatedAt",
        sortOrder: "DESC",
      }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

// Export submissions to CSV file
const exportSubmissionsCSV = async (event) => {
  try {
    const response = await fetch(`${mission.exportCSVRoute}?event=${event}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
    });
    
    if (response.ok) {
      // Lấy blob data
      const blob = await response.blob();
      
      // Tạo URL và trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `submissions_${event}_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      return { success: true };
    } else {
      console.error("Request failed:", response.status);
      throw new Error("Export failed");
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export {
  createSubmission,
  updateSubmission,
  getSubmissionById,
  getSubmission,
  updateSubmissionStatus,
  getSubmissionByLink,
  getAllSubmissions,
  exportSubmissionsCSV,
};